import { ItemPosition } from 'Shared/constants/types';
import { SourcePage } from 'Shared/types/SourcePage.type';

import { getSourcePage } from './getSourcePage';

export function getPositionFieldForItem() {
  const sourcePage = getSourcePage();

  switch (sourcePage) {
    case SourcePage.teamPage:
    case SourcePage.actionItems:
      return ItemPosition.positionForActionItemsPage;
    case SourcePage.homePage:
      return ItemPosition.positionForHomePage;
    case SourcePage.goalDetailPage:
      return ItemPosition.positionForGoalDetailPage;
    case SourcePage.workspace:
    default:
      return ItemPosition.positionForWorkspacePage;
  }
}
